import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Home from "./pages/Home";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import WhatsAppButton from "./Components/WhatsAppButton";
import ComingSoon from "./pages/ComingSoon";
import Shop from "./pages/Shop";
import Contact from "./pages/Contact";
import About from "./Components/About";

import AdminDashboard from "./Components/Admin/AdminDashboard";
import AdminLogin from "./Components/Admin/AdminLogin";
import AdminProducts from "./Components/Admin/AdminProducts";
import AdminCollections from "./Components/Admin/AdminCollections";
import ProductDetails from "./pages/ProductDetails";
import { CartProvider } from "./context/CartContext";
import Cart from "./pages/Cart";
import CustomerDetails from "./pages/CustomerDetails";
import PaymentMethod from "./pages/PaymentMethod";
import OrderSuccess from "./pages/OrderSuccess";
import Collections from "./pages/Collections";
import FAQ from "./pages/Faq";


/* 
   SCROLL TO TOP
 */

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [pathname]);

  return null;
}


/* 
   APP CONTENT
 */

function AppContent() {
  const location = useLocation();

  // Admin pages par public Navbar/Footer/WhatsApp hide
  const isAdminPage = location.pathname.startsWith("/admin");

  return (
    <>
      {/* Scroll page to top whenever route changes */}
      <ScrollToTop />

      <CartProvider>

        {!isAdminPage && <Navbar />}

        <Routes>

          <Route
            path="/"
            element={<Home />}
          />

          <Route
            path="/about"
            element={<About />}
          />

          <Route
            path="/shop"
            element={<Shop />}
          />

          <Route
            path="/customer-details"
            element={<CustomerDetails />}
          />

          <Route
            path="/payment-method"
            element={<PaymentMethod />}
          />

          <Route
            path="/order-success"
            element={<OrderSuccess />}
          />

          <Route
            path="/contact"
            element={<Contact />}
          />

          <Route
            path="/commingsoon"
            element={<ComingSoon />}
          />

          <Route
            path="/collections"
            element={<Collections />}
          />

          <Route
            path="/cart"
            element={<Cart />}
          />
<Route path="/faq" element={<FAQ />} />

          {/* =================================================
              ADMIN
          ================================================= */}

          <Route
            path="/admin/login"
            element={<AdminLogin />}
          />

          <Route
            path="/admin/dashboard"
            element={<AdminDashboard />}
          />

          <Route
            path="/admin/products"
            element={<AdminProducts />}
          />

          <Route
            path="/admin/collections"
            element={<AdminCollections />}
          />


          {/* =================================================
              PRODUCT DETAILS
          ================================================= */}

          <Route
            path="/product/:id"
            element={<ProductDetails />}
          />

        </Routes>

      </CartProvider>


      {!isAdminPage && <WhatsAppButton />}

      {!isAdminPage && <Footer />}
    </>
  );
}


/* 
   APP
 */

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;